/**
 * Coalesces the `focus` and `visibilitychange` events emitted together when a
 * browser tab returns to the foreground. Call `complete` when the resource
 * revalidation that `tryBegin` authorized has settled.
 */
export function createForegroundRevalidationGate() {
  let pending = false;
  let backgrounded = false;

  return {
    /** Record a real loss of page foreground before accepting a later focus event. */
    markBackgrounded() {
      backgrounded = true;
    },
    tryBegin() {
      if (pending) {
        return false;
      }
      pending = true;
      return true;
    },
    /**
     * A focus event alone is not a foreground transition: browsers can emit
     * it while an element inside the still-visible page receives focus. Only
     * refresh after a preceding blur or hidden state has been observed.
     */
    tryBeginAfterForeground() {
      if (!backgrounded || !this.tryBegin()) {
        return false;
      }
      backgrounded = false;
      return true;
    },
    complete() {
      pending = false;
    },
    get pending() {
      return pending;
    },
    get backgrounded() {
      return backgrounded;
    }
  };
}
